module.exports = __webpack_public_path__ + "img/license-CC BY-SA.1a549342.png";